import { InvalidInputError } from "@/errors/invalid-input.error";

const ErrorHandlerMixin = {

  methods: {

    
    handleErrorAsNotifications(err) {

      if(err instanceof InvalidInputError) {
        this.$notify({
          group: 'notices',
          title: err.msg,
          type: 'error',
        });
        return;
      }

      if(!err.response) {
        console.error('No response error:', err);
        return;
      }

      if(!err.response.data || !err.response.data.err) {
        return err;
      }

      if(typeof err.response.data.err === 'object') {
        for(let msg in err.response.data.err) {
          this.$notify({
            group: 'notices',
            title: `${err.response.data.err[msg]}`,
            type: 'error',
          });
        }
      }
      else if(typeof err.response.data.err === 'string') {
        this.$notify({
          group: 'notices',
          title: err.response.data.err,
          type: 'error',
        });
      }

      return err;
    }
  }
}

export { ErrorHandlerMixin }
